import { Injectable } from '@angular/core';
import { MonitoringApiService } from './monitoring-api.service';

@Injectable({ providedIn: 'root' })
export class EmulatorMonitoringApiService extends MonitoringApiService {
  protected get baseUrl(): string {
    return super.baseUrl.replace('monitoring', 'emulator-monitoring');
  }
}
